import $ from "jquery";
import { smoothscroll } from "../utils/smoothscroll";

const $modal = $("#suggestion-modal");
const $osEl = $(".ombudsman-scope");

$(function () {
  if ($osEl.length > 0) {
    $osEl.each(async function () {
      const $thisEl = $(this);
      ombudsmanScope($thisEl);
    });
  }
});

function ombudsmanScope(element) {
  const filter = {
    scope: null,
    lang: element.data("lang"),
  };

  const $menuItem = element.find(".ombudsman-scope__menu-item");
  handleMenuClick($menuItem.first(), filter);

  $menuItem.on("click", function () {
    const $thisEl = $(this);
    smoothscroll($thisEl);
    handleMenuClick($thisEl, filter);
  });

  element.on("click", ".ombudsman-scope__grid-item", function () {
    const $thisEl = $(this);
    toggleDetail($thisEl);
  });

  element.on("click", ".button.modal-trigger", function () {
    const $thisEl = $(this);
    const authorityName = $thisEl
      .closest(".ombudsman-scope__detail")
      .find(".ombudsman-scope__detail-heading")
      .html();
    const $options = $modal.find("select option");
    $options
      .filter(function () {
        const $thisEl = $(this);
        return $thisEl.text() === authorityName;
      })
      .prop("selected", true);
  });
}

function toggleDetail(element) {
  let showFlag = false;
  if (!element.hasClass("active")) {
    showFlag = true;
  }

  $(".ombudsman-scope__grid-item.active").removeClass("active");
  $(".ombudsman-scope__detail-wrapper.active").removeClass("active");

  if (showFlag === true) {
    showDetail(element);
  }
}

function showDetail(element) {
  element.addClass("active");
  const selector = "#" + element.data("id");
  element
    .closest(".ombudsman-scope__content")
    .find(selector)
    .addClass("active");

  smoothscroll("#ombudsman-scope__scrollpoint");
}

const handleMenuClick = async (element, filter) => {
  $(".ombudsman-scope__menu-item.active").removeClass("active");
  element.addClass("active");

  filter.scope = element.data("scope");
  const container = element
    .closest(".ombudsman-scope__container")
    .find(".ombudsman-scope__content");

  renderHtml(container, filter);
};

const renderHtml = async (container, filter) => {
  const html = await getHtml(filter);
  container.html(html.html);
};

const getHtml = async (filter) => {
  try {
    const response = await fetch(
      SITE_PARAMS.site_url + "/wp-json/kvop/v1/ombudsman-scope/html",
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(filter),
      }
    );
    const result = await response.json();
    return result;
  } catch (e) {
    console.log(e);
    return null;
  }
};
